import { PVP_REALMS, type RealmId } from '@mn/shared';

// ── Maps the monster-tamer "area" names (Tiled levels) onto Monstara realms. ──
// The Colyseus server runs one room per RealmId. Interiors/buildings stay in their
// parent realm. Extend this table as new areas are added in Tiled.
const AREA_TO_REALM: Record<string, RealmId> = {
  main_1: 'town',
  building_1: 'town',
  building_2: 'town',
  building_3: 'town',
  forest_1: 'wilds',
  // generated open-world (see scripts/gen-world.mjs)
  overworld_1: 'wilds',
  cave_1: 'wilds',
};

export const DEFAULT_REALM: RealmId = 'town';

/**
 * Resolve a game area key (e.g. "main_1", "FOREST_1") to a network RealmId.
 * Falls back to the town hub for anything unmapped so we always have a valid room.
 */
export function realmForArea(area: string | undefined): RealmId {
  if (!area) return DEFAULT_REALM;
  return AREA_TO_REALM[area.toLowerCase()] ?? DEFAULT_REALM;
}

/** Human-readable realm names for transition banners / system messages. */
export const REALM_LABELS: Record<RealmId, string> = {
  town: 'Town',
  wilds: 'The Wilds',
  badlands: 'The Badlands',
};

/** True when open-world PvP (and tombstone drops) are legal in this realm. */
export function isPvpRealm(realm: RealmId): boolean {
  return PVP_REALMS.includes(realm);
}
